import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ConfigService, TokenService } from 'viggo-sistemas-core-web';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface ISettings {
  [key: string]: any;
}
@Injectable()
export class ProdutosSettingsService {
  baseEntityEndPoint: string;
  urlBackend: string;

  constructor(
    protected http: HttpClient,
    protected configService: ConfigService,
    protected tokenService: TokenService
  ) {
    Object.assign(this, {
      baseEntityEndPoint: `produtos`,
      urlBackend: configService.backendURL
    });
  }

  getBaserUrl(id?: string): string {
    return `${this.urlBackend}${this.baseEntityEndPoint}/${id}/settings`;
  }

  insert(data: ISettings): Observable<ISettings> {
    const headers = new HttpHeaders().append(
      'token',
      this.tokenService.getToken().id
    );

    return this.http
      .post<{ settings: ISettings }>(this.getBaserUrl(), data, {
        headers
      })
      .pipe(map(item => item.settings));
  }

  update(data: ISettings, id: string): Observable<ISettings> {
    const headers = new HttpHeaders().append(
      'token',
      this.tokenService.getToken().id
    );

    return this.http
      .put<{ settings: ISettings }>(this.getBaserUrl(id), data, {
        headers
      })
      .pipe(map(item => item.settings));
  }

  delete(key: string): Observable<ISettings> {
    const headers = new HttpHeaders().append(
      'token',
      this.tokenService.getToken().id
    );

    return this.http
      .delete<{ settings: ISettings }>(`${this.getBaserUrl()}?keys=${key}`, {
        headers
      })
      .pipe(map(item => item.settings));
  }
}
